export default __webpack_public_path__ + "static/media/drstile-website-3.014b5986.jpg";